/* @flow */
import * as React from 'react';

import Columns2 from 'components/Columns2';
import Image from 'components/Image';
import Row from 'components/Row';
import Text from 'components/Text';

import SchoolViewContainer from '../SchoolViewContainer';

import './SchoolViewScreenshotFigures.scss';

type Props = {
  items: Array<{
    alt: string,
    caption: string,
    image: string,
    image2x: string,
  }>,
};

export default function SchoolViewScreenshotFigures({ items }: Props) {
  return (
    <SchoolViewContainer size="small" className="SchoolViewScreenshotFigures">
      <Columns2 reset="mobile">
        {items.map(item => (
          <figure key={item.caption}>
            <Row size="small">
              <Image
                src={item.image}
                srcSet={`${item.image2x} 2x`}
                alt={item.alt}
                className="SchoolViewScreenshotFigures-screenshot"
              />
            </Row>
            <Text align="center" element="figcaption" size="medium">
              {item.caption}
            </Text>
          </figure>
        ))}
      </Columns2>
    </SchoolViewContainer>
  );
}
